import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './en/common.json'
import enNav from './en/nav.json'
import enValidation from './en/validation.json'
import enLogin from './en/login.json'
import enSettings from './en/settings.json'
import enProfile from './en/profile.json'
import enModals from './en/modals.json'
import enTable from './en/table.json'
import enFieldEditor from './en/fieldEditor.json'
import enEmail from './en/email.json'
import enScheme from './en/scheme.json'
import enUsers from './en/users.json'
import enForm from './en/form.json'
import enMarketing from './en/marketing.json'
import enTemplate from './en/template.json'

import ruCommon from './ru/common.json'
import ruNav from './ru/nav.json'
import ruValidation from './ru/validation.json'
import ruLogin from './ru/login.json'
import ruSettings from './ru/settings.json'
import ruProfile from './ru/profile.json'
import ruModals from './ru/modals.json'
import ruTable from './ru/table.json'
import ruFieldEditor from './ru/fieldEditor.json'
import ruEmail from './ru/email.json'
import ruScheme from './ru/scheme.json'
import ruUsers from './ru/users.json'
import ruForm from './ru/form.json'
import ruMarketing from './ru/marketing.json'
import ruTemplate from './ru/template.json'

import esCommon from './es/common.json'
import esNav from './es/nav.json'
import esValidation from './es/validation.json'
import esLogin from './es/login.json'
import esSettings from './es/settings.json'
import esProfile from './es/profile.json'
import esModals from './es/modals.json'
import esTable from './es/table.json'
import esFieldEditor from './es/fieldEditor.json'
import esEmail from './es/email.json'
import esScheme from './es/scheme.json'
import esUsers from './es/users.json'
import esForm from './es/form.json'
import esMarketing from './es/marketing.json'
import esTemplate from './es/template.json'

export const supportedLanguages = ['en', 'ru', 'es'] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        nav: enNav,
        validation: enValidation,
        login: enLogin,
        settings: enSettings,
        profile: enProfile,
        modals: enModals,
        table: enTable,
        fieldEditor: enFieldEditor,
        email: enEmail,
        scheme: enScheme,
        users: enUsers,
        form: enForm,
        marketing: enMarketing,
        template: enTemplate,
      },
      ru: {
        common: ruCommon,
        nav: ruNav,
        validation: ruValidation,
        login: ruLogin,
        settings: ruSettings,
        profile: ruProfile,
        modals: ruModals,
        table: ruTable,
        fieldEditor: ruFieldEditor,
        email: ruEmail,
        scheme: ruScheme,
        users: ruUsers,
        form: ruForm,
        marketing: ruMarketing,
        template: ruTemplate,
      },
      es: {
        common: esCommon,
        nav: esNav,
        validation: esValidation,
        login: esLogin,
        settings: esSettings,
        profile: esProfile,
        modals: esModals,
        table: esTable,
        fieldEditor: esFieldEditor,
        email: esEmail,
        scheme: esScheme,
        users: esUsers,
        form: esForm,
        marketing: esMarketing,
        template: esTemplate,
      },
    },
    ns: [
      'common',
      'nav',
      'validation',
      'login',
      'settings',
      'profile',
      'modals',
      'table',
      'fieldEditor',
      'email',
      'scheme',
      'users',
      'form',
      'marketing',
      'template',
    ],
    defaultNS: 'common',
    fallbackLng: 'en',
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
